import {DialogContent, DialogContentText, DialogTitle, TextField} from "@mui/material";
import {Dialog2} from "../../../misc/Dialog2";
import {SmoothActionBar} from "../../../misc/SmoothActionBar";
import {useContext, useEffect, useState} from "react";
import {formatCents, parseCents, useAsyncAction} from "nate-react-api-helpers";
import {api} from "../../../api/API";
import {TableContext} from "../../../misc/scroller/Table";
import {getSectionName} from "./pricing/BeforeGroup";
import {SectionName} from "../../../api/QuotePricing";
import {useAlternative} from "./alternative/Alternative";
import {useSyncedRef} from "../../../misc/SyncedRef";

export function SectionTotal(props: {
    project: number;
    section: SectionName;
    value: number;
    onDone(): void;
}) {
    const [value, setValue] = useState("")

    useEffect(() => {
        setValue(formatCents(props.value));
    }, [props.value]);

    const onDoneRef = useSyncedRef(props.onDone);
    const tbl = useContext(TableContext)
    const tblReloadRef = useSyncedRef(tbl.reload);

    const action = useAsyncAction(async (input) => {
        if(isNaN(input.totalPriceCents)) {
            throw new Error("Invalid total price");
        }

        await api.quotePricing.scaleSection(input);
        onDoneRef.current();
        tblReloadRef.current(true);
    }, []);

    const alternative = useAlternative();

    const submit = () => {
        action.callback({
            project: props.project,
            alternative: alternative,
            type: props.section,
            totalPriceCents: parseCents(value),
        })
    };

    return (
        <Dialog2 open onClose={props.onDone} onEnterPress={submit}>
            <DialogTitle>
                Bulk Adjust {getSectionName(props.section)} Markup
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Adjusting this will adjust each {props.section} item's markup proportionally to make the total price ${value}.
                </DialogContentText>
                <div style={{height: 16}} />
                <TextField label="Total Price" value={value} onChange={e => setValue(e.target.value)} />
            </DialogContent>
            <SmoothActionBar
                loading={action.loading}
                error={action.error}
                actionName="Submit"
                onCancel={props.onDone}
                onSubmit={submit}
            />
        </Dialog2>
    )
}